import { Box, Typography, TextField, Button } from "@mui/material";
import React from "react";

export const Step6 = (props) => {
  const { register, errors, setUploadedPymeFiles, uploadedPymeFiles } = props;
  return (
    <Box sx={{ mt: 3 }}>
      <Typography variant="h6">Pérdida o Gasto Adicional</Typography>
      <Typography variant="subtitle1">
        En caso de ser PYME, ¿sufre pérdida de beneficios?
      </Typography>
      <Typography variant="subtitle1">
        Adjunte documento de cuenta de resultados del año pasado.
      </Typography>
      <Button variant="outlined" component="label" fullWidth sx={{ mb: 2 }}>
        Seleccionar archivos
        <input
          type="file"
          hidden
          multiple
          accept="image/*, video/*, application/pdf"
          onChange={(e) => {
            const newFiles = Array.from(e.target.files);
            setUploadedPymeFiles((prevFiles) => [...prevFiles, ...newFiles]);
          }}
        />
      </Button>

      {uploadedPymeFiles.length > 0 && (
        <Box sx={{ mt: 1 }}>
          <Typography variant="subtitle2">Archivos seleccionados:</Typography>
          <ul>
            {uploadedPymeFiles.map((file, index) => (
              <li key={index}>
                {file.name}
                <Button
                  variant="text"
                  color="error"
                  sx={{ ml: 2 }}
                  onClick={() => {
                    setUploadedPymeFiles((prevFiles) =>
                      prevFiles.filter((_, i) => i !== index)
                    );
                  }}
                >
                  ✖︎ Eliminar
                </Button>
              </li>
            ))}
          </ul>
        </Box>
      )}

      <Typography variant="subtitle1">
        En caso de ser vivienda. ¿Has tenido que alquilar otra vivienda?
      </Typography>
      <TextField
        {...register("alquiler")}
        label="Indique la dirección de la vivienda alquilada y el coste mensual."
        fullWidth
        multiline
        sx={{ mb: 2, mt: 2 }}
        error={!!errors.numeroEstancias}
        helperText={errors.numeroEstancias?.message}
      />
    </Box>
  );
};

export default Step6;
